import { render, staticRenderFns } from "./NukiSmartlockTable.global.vue?vue&type=template&id=89dac4ae&lang=pug&"
import script from "./NukiSmartlockTable.global.vue?vue&type=script&lang=ts&"
export * from "./NukiSmartlockTable.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports